import axios from 'axios'

const isDevelopment = process.env.NODE_ENV === 'development'

const instance = axios.create({
  // 开发环境使用本地Worker服务地址，生产环境使用云端地址
  baseURL: isDevelopment ? '/' : 'https://stockapi.baitiane.top/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 添加响应类型
    if (config.method === 'get') {
      config.params = {
        ...config.params,
        _t: Date.now() // 添加时间戳防止缓存
      }
    }
    
    // 添加认证token
    // const token = localStorage.getItem('token')
    // if (token && config.method !== 'options') {
    //   config.headers['Token'] = `Bearer ${token}`
    // }
    
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    // 如果远程API返回的数据格式与本地Worker不一致，在这里进行统一
    if (response.data && response.data.code !== undefined) {
      // 适配远程API格式
      return {
        ...response,
        data: {
          success: response.data.code === 0,
          data: response.data.data
        }
      }
    }
    return response
  },
  error => {
    return Promise.reject(error)
  }
)

export default instance